import React, { useEffect, useState } from "react";
import Select from "react-select";
import { components } from "react-select";
import registrationData from "./registrationData.json";
import { connect } from "react-redux";
import { Field } from "formik";
import CommonModal from "../utils/commonModal";
import Loading from "../utils/loader";
import { FaArrowAltCircleDown } from 'react-icons/fa';
import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from 'react-icons/md';
import CustomSelect from "./customSelect";
import updateProfileData from "./updateProfileData.json";
import { deviceType, isSignupPage, certificationPage } from "../../utils/registrationUtils";
import {Prefill_Fields} from "../../constants/registration";
import Cookies from "universal-cookie";

const CareersRegisterRadioSingleSelect = (props) => {
  const {
    name,
    values,
    setFieldValue,
    validationSchema,
    errors,
    touched,
    handleBlur,
    searchBar
  } = props;

  const [overlayActive, setOverlayActive] = useState(false);
  const [dropdownDatas, setDropdownDatas] = useState([]);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [searchData, setSearchData] = useState("");
  let signupUrl = window.location.pathname?.includes("/user/register");
  let completeProfileUrl = window.location.pathname?.includes("/user/complete-profile");
  const cookies = new Cookies();
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  let excludedDegreeDomainData = (props.domain?.id != 2 && props.domain?.id != 5) ?  cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.exc_degree_stream_ic : [];
  // To exclude degrees for first 5 options.
  const excludedCombinations = excludedDegreeDomainData?.length > 0 && new Set(
    excludedDegreeDomainData?.map((item) => {
      return item.domain_id ? `${item.id}_${item.domain_id}` : `${item.id}`;
    })  
  );
  useEffect(() => {
    let dropdownsData = [];
    if (props.dropdownData?.values?.length > 0) {
      dropdownsData = props.dropdownData?.values?.map((key) => {
        if (
          Array.isArray(key.values) &&
          key.values.length > 0 &&
          props.name != "education_interest"
        ) {
          return {
            label: key.label,
            options:
              key.values?.map((item) => ({
                id: item.id,
                label: item.value,
                domain_id: item.domain_id, 
                group_id: item.group_id,
                title: key.label
              }))
          };
        } else if (
          Array.isArray(key.values) &&
          key.values.length > 0 &&
          props.name == "education_interest"
        ) {
          // To exclude degrees for first 5 options.
          const filtered = key.values?.filter((item) => {
            const idKey = `${item.id}`;
            const comboKey = `${item.id}_${item.domain_id}`;
            if(excludedCombinations){
            // If item.id is globally excluded, skip it
            if (excludedCombinations?.has(idKey)) return false;
          
            // If specific id+domain_id is excluded, skip it
            if (excludedCombinations?.has(comboKey)) return false;
            }
            return true;
          });
          
          return {
            label: key.label == "Not Decided" ? "" : key.label,
            options: filtered?.slice(0, 5).map((item) => ({
              id: item.id,
              label: item.value,
              domain_id: item.domain_id,
              group_id: item.group_id,
              is_group: item.is_group
            }))
          };
        } else {
          return {
            id: key.id ?? key.branch_id,
            label: key.value,
            domain_id: key.domain_id,
          };
        }
      });
    }
    setDropdownDatas(dropdownsData);
  }, [props.dropdownData?.values, name]);

  // Done for prefilling values in predictor cases.
  useEffect(() => {
    if(dropdownDatas?.length && name === "education_level" && !props.isUpdateProfile){
      let valueToFindPrefillLevel = props.userDetails?.education_level
      ? {
          id: props.userDetails.education_level.id,
          title: props.userDetails.education_level.parent_level_name,
          label: props.userDetails.education_level.value,
          domain_id: props.userDetails.education_level.domain_id,
        }
      : null;
      let valueToFindLevel = completeProfileUrl ? valueToFindPrefillLevel : cookies.get("common_embbed_fields")?.formValues?.education_level;
      
      if(valueToFindLevel){
      const isValueIncluded = dropdownDatas?.some(group => 
      group.options.some(option => 
        option.id === valueToFindLevel?.id && 
        option.label === valueToFindLevel?.label && 
        option.title === valueToFindLevel?.title
      )
    );
    if(!isValueIncluded){
      props.setFormikValues((prev) =>({...prev, "education_level": null}));
      props.setReinitialize(true);
        setTimeout(() => props.setReinitialize(false), 50);
    }else if(isValueIncluded){
      if (!props.isUpdateProfile && props.domain?.id != 2) {
        props.apiCallBasedOnStudyingIn(name, valueToFindLevel);
      }
    }
  }
  }
    if (dropdownDatas?.length && (name === "education_level" || name === "education_interest") && (signupUrl || completeProfileUrl)) {
      PrefillDataForUrls();
    }
  }, [dropdownDatas, name]);

  const educationInterestInputChange = (e) => {
   
    setSearchData(e);
    let dropdownsData = [];
    if (props.dropdownData?.values?.length > 0 && props.name == "education_interest") {
      dropdownsData = props.dropdownData?.values?.map((key) => {
        if (
          Array.isArray(key.values) &&
          key.values.length > 0
        ) {
          // To exclude degrees for first 5 options.
          const filtered = key.values?.filter((item) => {
            const idKey = `${item.id}`;
            const comboKey = `${item.id}_${item.domain_id}`;
            if(excludedCombinations){

            // If item.id is globally excluded, skip it
            if (excludedCombinations?.has(idKey)) return false;
          
            // If specific id+domain_id is excluded, skip it
            if (excludedCombinations?.has(comboKey)) return false;
            }
            return true;
          });
                    
          return {
            label: key.label == "Not Decided" ? "" : key.label,
            options: e?.length > 0 ? key.values?.map((item) => ({
              id: item.id,
              label: item.value,
              domain_id: item.domain_id,
              group_id: item.group_id,
              is_group: item.is_group
            })) :
            filtered?.slice(0, 5)?.map((item) => ({
                id: item.id,
                label: item.value,
                domain_id: item.domain_id,
                group_id: item.group_id,
                is_group: item.is_group
              }))
          };
        } else {
          return {
            id: key.id ?? key.branch_id,
            label: key.value,
            domain_id: key.domain_id,
          };
        }
      })
      setDropdownDatas(dropdownsData);
    }
    return e
  }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {props.selectProps.menuIsOpen ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}
      </components.DropdownIndicator>
    );
  };

  const Option = (props) => {
    return (
      <div>
        {props?.label &&
          <components.Option {...props} className={!props.isSelected ? 'bg-white' : 'bg_gray'}>
            {/* add this to show purple radio <span className={`careers_register_custom_checkbox`}> */}
              <span className={`careers_register_custom_checkbox`}>
                <input type="radio" checked={props.isSelected} />{" "}
                <label className="radio_label">{props.label}</label>
            </span>
          </components.Option>
        }
      </div>
    );
  };

  const handleFocus = (event, name) => {
    setOverlayActive(true);
  };

  const handleCloseModal = () => {
    setShow(false);
  }

  const handleRadioChange = (selectedItem) => {
    if (name === 'education_level') {
      const secondaryFieldsTouched = {};
        if(props.isUpdateProfile){
            updateProfileData?.data
            ?.find((obj) => obj.domain === props.domain?.id)
            ?.fields?.forEach((item) => {
              if (item.type === "Secondary" && item.education_level?.length > 0) {
                // Clear field value
                props.setFieldValue(item.alternate_name, null);
                // Set touched state to false for secondary fields
                secondaryFieldsTouched[item.alternate_name] = false;
              }
            });
          }else {
          registrationData?.data
            ?.find((obj) => obj.domain === props.domain?.id)
            ?.fields?.forEach((item) => {
              if (item.type === "Secondary" && item.education_level?.length > 0) {
                // Clear field value
                props.setFieldValue(item.name, null);
                // Set touched state to false for secondary fields
                secondaryFieldsTouched[item.name] = false;
              }
            });
          }
      // Update touched state for secondary fields
      props.updateTouchedFields({
        ...props.touched,
        ...secondaryFieldsTouched
      });
      props.setTouched({
        ...props.touched,
        ...secondaryFieldsTouched
      })
      // Set field value for the current field
    }
    props.setFieldValue(props.name, selectedItem);
    handleCloseModal();

    // left shift issue after modal is closed
    setTimeout(() => {
      document.getElementById('manage_dropdown_leftshift')?.focus();
    }, 1000)
  };
  const customFilter = (option, rawInput) => {
    const inputValue = rawInput?.toLowerCase().replace(/\./g, ''); // Remove all dots from the search input
    const label = option.label?.toLowerCase().replace(/\./g, ''); // Remove all dots from the option label
    return label?.includes(inputValue);
  };
  // Done for prefilling values in predictor cases.
  const PrefillDataForUrls = () => {
    Prefill_Fields?.filter((obj) => {
      if (window.location.href?.includes(obj.url)) {
        const combinedOptions = dropdownDatas?.flatMap((item) => item.options || []);
        const level = combinedOptions.find((data) => data?.id === obj.id);
        props.setFormikValues((prev) => {
          let updatedValues = { ...prev };
  
          if (name === "education_level") {
            updatedValues.education_level = level;
            if (!props.isUpdateProfile) {
              props.apiCallBasedOnStudyingIn(name, level);
            }
          }
          if (
            name === "education_interest" &&
            (obj?.id == 12 ? updatedValues.education_level?.id === 12 : updatedValues.education_level?.id === 22)
          ) {
            updatedValues.education_interest = combinedOptions?.[0];
          }
          return updatedValues;
        });
  
        props.setReinitialize(true);
        setTimeout(() => props.setReinitialize(false), 50);
      }
    });
  };
  

  return (
    <div className={values[name] || errors[name] ? "careers_register_select_card studyin_modal white_bg" :"careers_register_select_card studyin_modal"}>
      {deviceType == "mobile" && <CommonModal
        isOpen={show}
        closeModal={() =>{ 
           props.setTouched({
            ...props.touched,[name]:true
          })
          handleCloseModal();}}
        showCloseIcon
        classNames={{
          root: "mobile_modal",
          modal: 'custom_modal',
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
        }}
        animationDuration={800}
      >
        <div className="careers_register_dropdown_studying_in_cover">
          <span className={searchBar ? "careers_register_dropdown_heading search_bar":"careers_register_dropdown_heading studying_in"}><b>{props.placeholder}</b></span>
          <div className={`inner_studyin_modal ${searchBar ? 'search_dropdown_modal' : 'studying_in'}`}>
            {deviceType == "mobile" &&
              searchBar ? (
              <>
                <CustomSelect
                  options={dropdownDatas}
                  name={name}
                  isSearchable={name == "education_interest" ? true : false}
                  backspaceRemovesValue={false}
                  onInputChange={(e) => educationInterestInputChange(e)}
                  placeholder={!searchBar ?? 'Search...'}
                  components={{ Option: Option }}
                  getOptionLabel={(opt) => opt.label}
                  getOptionValue={(opt) => opt.id ? `${opt.id}_${opt.domain_id}_${opt.group_id}` : opt.domain_id}
                  value={props.values?.[props?.name] ? props.values?.[props?.name] : {}}
                  controlShouldRenderValue={false}
                  errors={(errors[name] && touched[name])}
                  onChange={(option) => {
                     sessionStorage.removeItem("up_domain_id");
                    if (name === 'education_interest' && !props.isUpdateProfile) {
                        props.setFieldValue("target_year",'');
                        props.apiCallBasedOnStudyingIn(name, option); // for signup 
                    }
                    if(name === 'education_interest' && props.isUpdateProfile){
                        sessionStorage.setItem("up_domain_id",option?.domain_id)
                        props.postUpdateProfileOnChange(undefined, undefined, undefined, undefined, false);
                    }
                    if(props.isUpdateProfile){
                      props.setFieldValue("target_year",'');
                    }
                    if (name === 'education_level') {
                      const secondaryFieldsTouched = {};
                      registrationData?.data
                        ?.find((obj) => obj.domain === props.domain?.id)
                        ?.fields?.forEach((item) => {
                          if (item.type === "Secondary" && item.education_level?.length > 0) {
                            // Clear field value
                            props.setFieldValue(item.name, null);
                            // Set touched state to false for secondary fields
                            secondaryFieldsTouched[item.name] = false;
                          }
                        });
                      // Update touched state for secondary fields
                      props.updateTouchedFields({
                        ...props.touched,
                        ...secondaryFieldsTouched
                      });
                      props.setTouched({
                        ...props.touched,
                        ...secondaryFieldsTouched
                      })
                      // Set field value for the current field
                    }
                    if (name === 'education_interest' && props.domain?.id == 2) {
                      props.areaOfInterestApiCall(undefined,undefined, option, undefined);
                      if(props.isUpdateProfile){
                      props.postUpdateProfileOnChange(undefined,undefined, option, undefined, false);
                      }
                    }
                    props.setFieldValue(props.name, option);
                    handleCloseModal();
                  }}
                  formatOptionLabel={(option) => (
                    props.name == "education_level" ? `${option.title} - ${option.label}` : option.label)}
                  noOptionsMessage={({ inputValue }) =>
                    (props.education_level_loading || props.educationInterestLoading) ? (
                      <Loading /> // You can replace this with your custom loader message
                    ) : (
                      "No options found"
                    )
                  }
                  filterOption={(option, inputValue) => {
                    if (name === "education_interest") {
                      return customFilter(option, inputValue);
                    } else {
                      return true;
                    }
                  }}
                  // menuShouldScrollIntoView={false}
                  styles={{
                    container: (base, state) => ({
                      ...base,
                      // margin: "20px 0px 1px",
                    }),
                    groupHeading:(base,state)=>({
                      ...base,
                      textTransform:"capitalize",
                      fontSize:"12px",
                      fontWeight:"500",
                    }),
                    menu: (base, state) => ({
                      ...base,
                      position: "relative",
                      marginTop: "0px",
                      boxShadow: "none",
                      borderRadius: "0px",
                      marginBottom: "0px",
                    }),
                    menuList: (base, state) => ({
                      ...base,
                      maxHeight: "350px",
                      // maxHeight: "auto !important",
                      // padding: "0px 20px",
                    }),
                    option: (base, state) => ({
                      ...base,
                      background: state.isSelected ? 'rgba(0, 0, 0, 0.04) !important' : '#fff',
                      color: '#111',
                    }),
                    group: (base, state) => ({
                      ...base,
                      paddingLeft: "0px",
                      paddingRight: "0px",
                      borderBottom: (registrationData?.data?.find((obj) => obj.domain.domain == 1) ? "0px" : "1px solid #ccc"),
                      ":last-child": {
                        border: "0px",
                      },
                    }),

                    control: (base, state) => ({
                      ...base,
                      // margin: "0px 20px",
                      borderColor: "#ccc",
                      background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                      borderRadius: "3px",
                      minHeight: "42px",
                      boxShadow: "none",
                      // border:(errors[name] && touched[name]) && '1px solid #b3261e',
                      ":hover": {
                        borderColor: "#ccc",
                      },
                    }),
                    valueContainer: (base, state) => ({
                      ...base,
                      padding: "5px 8px 5px 10px",
                      // overflow: "visible",
                    }),
                  }}
                label={'label'}
                />
              </>
            ) :
              <div className="careers_radio_group studying_in">
                {(props.education_level_loading || props.educationInterestLoading) ? <Loading /> : (
                  <>
                    {Object.keys(dropdownDatas).map((key) => (
                      <div className={registrationData?.data?.find((obj) => obj.domain.domain == 1) ? "group_item remove_border" : "group_item studying_in"} key={key}>
                        <h5
                          onClick={(e) => handleCloseModal()}
                        >{dropdownDatas[key].label}</h5>
                        <div className="careers_list_item">
                          {Array.isArray(dropdownDatas[key].options)
                            ? dropdownDatas[key]?.options?.map((listItem) => (
                              <label key={`${listItem.id}_${listItem.domain_id}`} htmlFor={`${listItem.id}_${listItem.domain_id}`}>
                                <input
                                  type="radio"
                                  name={name}
                                  id={`${listItem.id}_${listItem.domain_id}`}
                                  onChange={() => {
                                    handleRadioChange(listItem);
                                    if (name === 'education_level') {
                                      props.setFieldValue("applied_area_of_interest", null);
                                      props.setSelectedAreaOfInterestValues([]);
                                      isSignupPage && props.setSyncSignupValues((prev) => ({ ...prev, "education_level": listItem }))
                                      if(!props.isUpdateProfile){
                                        if(completeProfileUrl){
                                          props.signupDataPost("save", listItem, null, null, null); 
                                         }
                                      props.apiCallBasedOnStudyingIn(name, listItem);
                                      }
                                      if(props.isUpdateProfile){
                                        const isLevel = true;
                                        props.postUpdateProfileOnChange(listItem, undefined, undefined, undefined, isLevel);
                                      }
                                    }
                                  }}
                                  checked={`${listItem.id}_${listItem.domain_id}` === `${values?.[name]?.id}_${values?.[name]?.domain_id}`}
                                />
                                <span className={`design ${`${listItem.id}_${listItem.domain_id}` === `${values?.[name]?.id}_${values?.[name]?.domain_id}` ? "checked" : ""}`}></span>
                                <span className="text">{listItem.label}</span>
                              </label>
                            ))
                            : typeof dropdownDatas[key] === 'object' &&
                            Object.keys(dropdownDatas[key]).map((subKey) => (
                              Array.isArray(dropdownDatas[key][subKey])
                                ? dropdownDatas[key][subKey].map((listItem) => (
                                  <label key={listItem.id} htmlFor={listItem.id}>
                                    <input
                                      type="radio"
                                      value={listItem.label}
                                      name={subKey}
                                      id={listItem.id}
                                      onClick={(e) => {
                                        if (name === 'education_level') {
                                          const secondaryFieldsTouched = {};
                                          registrationData?.data
                                            ?.find((obj) => obj.domain === props.domain?.id)
                                            ?.fields?.forEach((item) => {
                                              if (item.type === "Secondary" && item.education_level?.length > 0) {
                                                // Clear field value
                                                props.setFieldValue(item.name, null);
                                                props.setSelectedAreaOfInterestValues([]);
                                                // Set touched state to false for secondary fields
                                                secondaryFieldsTouched[item.name] = false;
                                              }
                                            })
                                          // Update touched state for secondary fields
                                          props.updateTouchedFields({
                                            ...props.touched,
                                            ...secondaryFieldsTouched
                                          });
                                          props.setTouched({
                                            ...props.touched,
                                            ...secondaryFieldsTouched
                                          })
                                          // Set field value for the current field
                                        }
                                        props.setFieldValue(props.name, listItem);
                                        handleCloseModal()
                                      }}
                                    />
                                    <span className="design"></span>
                                    <span className="text">{"listItem.label"}</span>
                                  </label>
                                ))
                                : null
                            ))}
                        </div>
                      </div>
                    ))}
                  </>)}
              </div>
            }
          </div>
        </div>
      </CommonModal>}

      {/* Select for Web */}
      {deviceType == "web" && (
        <>
        
          <CustomSelect
            options={dropdownDatas}
            name={name}
            backspaceRemovesValue={false}
            isSearchable={name == "education_interest" ? true : false}
            onFocus={(e, item) => props.name != "education_level" && props.handleOnFocus(e, name, item)}
            onBlur={handleBlur(name)}
            placeholder={!searchBar ?? 'Search...'}
            components={!searchBar ? { Option: Option,DropdownIndicator: DropdownIndicator }:{ Option: Option}}
            getOptionLabel={(opt) => opt.label}
            getOptionValue={(opt) => opt.id ? `${opt.id}_${opt.domain_id}_${opt.group_id}` : opt.domain_id}
            value={props.values?.[props?.name]}
            errors={(errors[name] && touched[name])}
            onChange={(option) => {
                sessionStorage.removeItem("up_domain_id");
               if (name === 'education_interest' && !props.isUpdateProfile) {
                  props.apiCallBasedOnStudyingIn(name, option); // for signup 
                  props.setFieldValue("target_year",'');
               }
               if(name === 'education_interest' && props.isUpdateProfile){
                  sessionStorage.setItem("up_domain_id",option?.domain_id)
                  props.postUpdateProfileOnChange(undefined, undefined, undefined, undefined, false);
               }
              if (name === 'education_level') {
                if(isSignupPage) props.setSyncSignupValues((prev) => ({ ...prev, "education_level": option }));

                if(!props.isUpdateProfile){
                  if(completeProfileUrl){
                   props.signupDataPost("save", option, null, null, null); 
                  }
                 
                props.apiCallBasedOnStudyingIn(name, option);
                }
               
                const secondaryFieldsTouched = {};

                if(props.isUpdateProfile){
                  const isLevel = true;
                  updateProfileData?.data
                  ?.find((obj) => obj.domain === props.domain?.id)
                  ?.fields?.forEach((item) => {
                    if (item.type === "Secondary" && item.education_level?.length > 0) {
                      // Clear field value
                      props.setFieldValue(item.alternate_name, null);
                      // Set touched state to false for secondary fields
                      secondaryFieldsTouched[item.alternate_name] = false;
                    }
                  });
                props.postUpdateProfileOnChange(option, undefined, undefined, undefined, isLevel);
                }else {
                registrationData?.data
                  ?.find((obj) => obj.domain === props.domain?.id)
                  ?.fields?.forEach((item) => {
                    if (item.type === "Secondary" && item.education_level?.length > 0) {
                      // Clear field value
                      props.setFieldValue(item.name, null);
                      // Set touched state to false for secondary fields
                      secondaryFieldsTouched[item.name] = false;
                    }
                  });
                }
                // Update touched state for secondary fields
                props.updateTouchedFields({
                  ...props.touched,
                  ...secondaryFieldsTouched
                });
                props.setTouched({
                  ...props.touched,
                  ...secondaryFieldsTouched
                })
              }
              if (name === 'education_interest' && props.domain?.id == 2) {
                  props.areaOfInterestApiCall(undefined,undefined, option, undefined);
                if(props.isUpdateProfile){
                  
                props.postUpdateProfileOnChange(undefined,undefined, option, undefined, false);
                }
              }
              props.setFieldValue(name, option);
              if(props.isUpdateProfile){
                props.setFieldValue("target_year",'');
              }
            }}
            onInputChange={(e) => educationInterestInputChange(e)}
            noOptionsMessage={({ inputValue }) =>
              (props.education_level_loading || props.educationInterestLoading) ? (
                <Loading /> // You can replace this with your custom loader message
              ) : (
                "No options found"
              )
            }
            formatOptionLabel={(option) => (
              (props.name == "education_level" && option.title == "School") ? `${option.title} - ${option.label}`
                : props.name == "education_level" ? `${option.label} - ${option.title}` : option.label)}
            filterOption={(option, inputValue) => {
              if (name === "education_interest") {
                return customFilter(option, inputValue);
              } else {
                return true;
              }
            }}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "#ccc",
                background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                borderRadius: "3px",
                height: "42px",
                boxShadow: "none",
                border: (errors[name] && touched[name] && !state.menuIsOpen) && '1px solid #b3261e',
                ":hover": {
                  borderColor: (errors[name] && touched[name] && !state.menuIsOpen) ? '#b3261e' : '#ccc',
                },
              }),
              valueContainer: (base, state) => ({
                ...base,
                padding: "5px 8px 14px 10px",
                // overflow: "visible",
              }),
              menu:(base,state)=>({
                ...base,
                marginTop:"4px",
              }),
              group: (base, state) => ({
                ...base,
                borderBottom: (registrationData?.data?.find((obj) => obj.domain.domain == 1) ? "0px" : "1px solid #ccc"),
                ":last-child": {
                  border: "0px",
                },
              }),
              groupHeading:(base,state)=>({
                ...base,
                textTransform:"capitalize",
                fontSize:"12px",
                fontWeight:"500",
              }),
              dropdownIndicator: (provided, state) => ({
                ...provided,
                color: state.isFocused ? "#999" : "#999",
                fontSize: "24px",
                position: 'relative',
                bottom: '7px',
                display: (searchBar) && 'none',
                ":hover": {
                  borderColor: "#999"
                }
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display: 'none',
              }),
              option: (base, state) => ({
                ...base,
                background: state.isSelected || state.isFocused  ? 'rgba(0, 0, 0, 0.04) !important' : '#fff',
                color: '#111',
              }),
              menuList: (base) => ({
                ...base,
                "::-webkit-scrollbar": {
                  width: "4px",
                  height: "0px",
                },
                "::-webkit-scrollbar-track": {
                  background: "#F1F1F1",
                },
                "::-webkit-scrollbar-thumb": {
                  background: "#999",
                },
                "::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
              }),
            }}
            // placeholder={props.placeholder}
            label={'label'}
          />
          <span className={(values[name] || searchData) ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
        </>
      )}

      {/* Select for Wap */}
      {deviceType == "mobile" &&
        <div className={(errors[name] && touched[name] && !values[name] && !show) ? "careers_register_form_card invalid_field" : values[name] ? "careers_register_form_card white_bg" : "careers_register_form_card"}
        // to get clicked on overall field.
        onClick={(e, item) => {
          if(window.location.pathname?.includes("user/update-profile")){
          props.handleOnFocus(e, name, item);
          }
          setShow(true);
        }}
        >
          <Field type="text"
            className="input_type_text"
            name={name}
            onFocus={() => {
              handleFocus;
            }}
            onBlur = {() => {}}
            value={(values[name] && name == "education_level" && values[name]?.title == "School") ?
              `${values[name]?.title} - ${values[name]?.label}` : values[name] && name == "education_level" ?
                `${values[name]?.label} - ${values[name]?.title}` : (values[name]?.label || values[name]?.value) ? values[name]?.label || values[name]?.value : ""}
            readOnly
          />
          <span className={(values[name] || searchData) ? 'floating_label_active' : "floating_label"}>{props.placeholder}</span>
          <div className='custom_Select_indicator_wap'>
            {show ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}</div>

        </div>
      }
      {
        errors[name] && touched[name] && !values[name] && !show && (
          <div className="invalid_card">
            <span className="invalid_card_text">{errors[name]}</span>
          </div>
        )
      }

    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    education_level_loading: state.userSignUpFields.educationLevelFieldLoading,
    educationInterestLoading: state.userSignUpFields.educationInterestLoading,
    userDetails: state.usersCommonData?.userInfo
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterRadioSingleSelect);
